import LearnAudioDescriptionDefault from './component.jsx'
export default LearnAudioDescriptionDefault
